//#region src/link-detection.ts
const MAX_LINKIFIED_LENGTH = 1e4;
const linkDetectionOptions = {
	defaultProtocol: "https",
	validate: (value, type) => type === "url" && /^(?:https?:\/\/|www\.)/i.test(value)
};
//#endregion
export { linkDetectionOptions as n, MAX_LINKIFIED_LENGTH as t };

//# sourceMappingURL=link-detection-gp7k5p_k.mjs.map